<template>
  <div>
    <div class="separator" v-if="(showDangerousGoods || showTemperature) && showSeparator"></div>
    <div
      v-if="showDangerousGoods"
      class="m-r-40 d-inline-block"
      :class="value.isDgToggleActive ? 'm-b-input' : ''">
      <Toggle
        class="m-r-10"
        :id="`dg-${customId}`"
        :label="label ? $t(label) : $t('dangerous_goods')"
        v-model="value.isDgToggleActive"
      />
      {{ label ? $t(label) : $t('dangerous_goods') }}
    </div>
    <div
      v-if="showTemperature"
      class="m-r-40 d-inline-block"
      :class="value.isTemperature ? 'm-b-input' : ''">
      <Toggle
        class="m-r-10"
        :id="`tmp-${customId}`"
        @change="setManualTemp()"
        :label="$t('Temperature controlled')"
        v-model="value.isTemperature"
      />
      {{ $t('Temperature controlled') }}
    </div>
    <div v-if="value.isTemperature && showTemperature" class="row m-b-30">
      <div class="col-xs-6">
        <InputText
          :label="$t('min_temperature')"
          v-model="value.minTemperature"
          :rules="{required: true}"/>
      </div>
      <div class="col-xs-6">
        <InputText
          :label="$t('max_temperature')"
          v-model="value.maxTemperature"
          :rules="{required: true}"/>
      </div>
    </div>
    <div v-if="showDangerousGoods && value.isDgToggleActive">
      <DangerousGoodsBlock
        @input="setDg"
        :dgTypeShownOnPackageCustomId="dgTypeShownOnPackageCustomId"
        :customId="customId"
        :value="value"
      />
    </div>
  </div>
</template>

<script>
import DangerousGoodsBlock from '@/components/shipments/dangerousGoodsBlock.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import InputText from '@/components/elements/inputs/text.vue';

export default {
  name: 'bookingDgBlock',
  components: { InputText, Toggle, DangerousGoodsBlock },
  props: {
    showDangerousGoods: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      required: false,
    },
    showTemperature: {
      type: Boolean,
      required: true
    },
    showSeparator: {
      type: Boolean,
      required: false,
      default: true
    },
    dgTypeShownOnPackageCustomId: {
      type: String,
      required: true
    },
    customId: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    setDg(event) {
      this.$emit('input', event)
    },
    setManualTemp() {
      if (this.value.isTemperature) {
        this.value.tempSetManually = true
      } else {
        this.value.tempSetManually = false
      }
    }
  }
}
</script>

<style scoped>

</style>
